define('views/pages/multi-account/transfer-content',['require','underscore','lib/utils','views/base/form','text!templates/pages/multi-account/transfer-content.ejs'],function(require) {
    'use strict';

    var     _ = require('underscore'),
        utils = require('lib/utils'),
        FormView = require('views/base/form'),
        template = require('text!templates/pages/multi-account/transfer-content.ejs');

    function templateAccount(item) {
        return $(
            item.loading ? item.text :
            (
                '<span class="transfer-account-item"><span class="transfer-account-item__icon">' +
                item.text +
                '</span><span class="transfer-account-item__value transfer-account-item__value-'  +
                (item.item.balance > 0 ? 'positive' : 'negative') +
                '">' +
                utils.money(item.item.balance) +
                '</span></span>'
            )
        );
    }

    function transformData(fieldId, fieldText) {
        return function(item) {
            return {
                id: item[fieldId],
                text: item[fieldText],
                item: item
            };
        };
    }

    var ContentView = FormView.extend({
        autoRender: true,
        region: 'modal-content',
        className: 'form-horizontal mb0',
        template: template,
        customValidation: true,
        listen: {
            'change:lastDocumentNumber model': 'render',
            'change:currencyCode model': 'updateCurrency',
            'change:commissionValue model': 'updateCommissionValue',
            'change:value model': 'updateCommissionValue',
            'change:stage model': 'render',
            'change:selectedAccount model': 'setSelectedAccount',

            'change:contractors model': 'render',
            'change:contractorTypes model': 'render',
            'change:contractorTypeId model': 'render',
            'change:contractorId model': 'render'
        },
        updateCurrency: function() {
            var cc = this.model.get('currencyCode');
            this.$('.input-sum small').text(cc);
            this.$('#commission small').text(cc);
            this.$('#finalSum small').text(cc);
        },
        updateCommissionValue: function() {
            var model = this.model;

            var commissionValue = model.get('commissionValue');
            var value = parseInt(model.get('value'), 10);

            var commission = model.get('activeCommission');

            if (commission) {
                this.$('#commission .commission__value').text((commission.type === 'percent' ? commission.value + '% - ' : '')  + utils.money(commissionValue));
            } else {
                this.$('#commission .commission__value').text('Нет комиссии');
            }
            this.$('#finalSum .commission__value').text(utils.money(value + commissionValue));
        },
        render: function() {
            FormView.prototype.render.apply(this, arguments);

            var $input = this.$('.price-input');

            $input.on('focus', function() {
                var f = parseFloat($input.val());
                if (f === 0 || isNaN(f)) {
                    $input.val('');
                }
            });

            $input.on('blur', function() {
                var f = parseFloat($input.val());
                if (f === 0 || isNaN(f)) {
                    $input.val('0.00');
                }
            });


            var model = this.model;
            var stage = model.get('stage');

            if (stage === 'confirm') {
                this.$el.addClass('form-wide');
            }

            if (stage === 'start') {
                var $account = this.$('#transfer-account');
                var $contractorType = this.$('#transfer-contractor-type');
                var $contractor = this.$('#transfer-contractor');
                var $contractorNumber = this.$('#transfer-contractor-number');

                $contractorType
                    .css({ width: '220px' })
                    .select2({})
                    .on('select2:select', this.changedAttribute.bind(this));

                $contractor
                    .css({ width: '220px' })
                    .select2({})
                    .on('select2:select', this.changedAttribute.bind(this));

                $contractorNumber
                    .css({ width: '220px' })
                    .select2({})
                    .on('select2:select', this.changedAttribute.bind(this));


                $account
                    .css({ width: '220px' })
                    .select2({
                        placeholderOption: function () { return undefined; },
                        data: this.model.get('page').get('accounts').get('items').map(transformData('currencyId', 'currencyCode')),
                        templateSelection: templateAccount,
                        templateResult: templateAccount
                    })
                    .on('select2:select', function(ev) {
                        var account = ev.params.data.item;

                        model.set({
                            'selectedAccount': account
                        });
                    });

                if (model.get('selectedAccount')) {
                    $account.val(model.get('selectedAccount').currencyId).trigger('change');
                }

                this.updateCommissionValue();
                this.updateCurrency();
            }

        },

        setSelectedAccount: function() {
            var model = this.model;
            console.log('selectedAccount', arguments, model.get('selectedAccount'));
            this.$('#transfer-account').val(model.get('selectedAccount').currencyId).trigger('change');
        }
    });

    return ContentView;
});

